import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';

import FileDownload from 'js-file-download';

function formataData(value){
  if (value) {
      return moment(value).format("DD/MM/YYYY");
  }
  return ''
}

export const state = {
  formasPagamento: [{code: 'Boleto', name: 'Boleto'}, {code: 'carne', name: 'Carnê'}, {code: 'cartaoCredito', name: 'Cartão Crédito'}, {code: 'dinheiro', name: 'Dinheiro'}],
  statusPedido: [{code: 'paid', name: 'Pago'}, {code: 'Inadimplente', name: 'Inadimplente'}, {code: 'Cancelado', name: 'Cancelado'}, {code: 'waiting', name: 'Aguardando pagamento'}, {code: 'rejected', name: 'Rejeitado'}, {code: 'failure', name: 'Falha'}, {code: 'processing', name: 'Processando'}],
  statusCobranca:[{code: 'paid', name: 'Pago'}, {code: 'waiting', name: 'Aguardando pagamento'}, {code: 'vencido', name: 'Vencido'}],
  filtro: {
    empresa: [],
    dataInicial: moment().subtract("1","month").toDate(),
    dataFinal: moment().toDate(),
    formaPagamento: null,
  },
  filtroFatura: {
    empresa: [],
    dataInicial: moment().subtract("1","month").toDate(),
    dataFinal: moment().toDate(),
    formaPagamento: null,
    tipo: null,
  },
  filtroEnvio: null,
  exibicaoFiltro: [],
  exibicaoFiltroFatura: [],
  pagination: null
};

export const getters = {
  step: (state) => state.step,
  formasPagamento: (state) => state.formasPagamento,
  statusPedido: (state) => state.statusPedido,
  statusCobranca: (state) => state.statusCobranca,
  filtro: (state) => state.filtro,
  filtroFatura: (state) => state.filtroFatura,
  filtroEnvio: (state) => state.filtroEnvio,
  exibicaoFiltro: (state) => state.exibicaoFiltro,
  exibicaoFiltroFatura: (state) => state.exibicaoFiltroFatura,
  pagination: (state) => state.pagination,
};

export const mutations = {
  setStep: (state, payload) => {
    state.step = payload;
  },
  setFiltro: (state, payload) => {
    state.filtro = payload;
  },
  setFiltroFatura: (state, payload) => {
    state.filtroFatura = payload;
  },
  setExibicaoFiltro: (state, payload) => {
    state.exibicaoFiltro = payload;
  },
  setExibicaoFiltroFatura: (state, payload) => {
    state.exibicaoFiltroFatura = payload;
  },
  setFiltroEnvio: (state, payload) => {
    state.filtroEnvio = payload;
  },
  setPagination: (state, payload) => {
    state.pagination = payload;
  }
};

export const actions = {
  setFiltro(state, payload) {
    state.commit('setFiltro', payload);
  },
  setFiltroFatura(state, payload) {
    state.commit('setFiltroFatura', payload);
  },
  setPagination(state, payload) {
    state.commit('setPagination', payload);
  },
  setStep({ commit }, payload) {
    commit("setStep", payload);
  },
  buildExibeFiltro(state, {fatura}) {
    const exibicao = [];
    const filtro = fatura ? state.getters.filtroFatura : state.getters.filtro;

    if (filtro.empresa && filtro.empresa.length > 0) {
      exibicao.push({
        name:"Empresa",
        mostrar:filtro.empresa.map(e => " " + e.name).toString().
          replace(/[\\[\\]\\"]/, '')
      })
    }
    if (filtro.dataInicial && filtro.dataFinal) {
      exibicao.push({
        name:"Intervalo",
        mostrar: `De ${formataData(filtro.dataInicial)} até ${formataData(filtro.dataFinal)}`
      })
    }

    if (fatura) {
      if (filtro.formaPagamento && filtro.formaPagamento.length > 0) {
        exibicao.push({
          name:"Forma de pagamento",
          mostrar: filtro.formaPagamento.map(fp => " " + fp.name).toString().
            replace(/[\\[\\]\\"]/, '')
        })
      }
      if (filtro.statusCobranca && filtro.statusCobranca.length > 0) {
        exibicao.push({
          name:"Status Cobrança",
          mostrar: filtro.statusCobranca.map(fp => " " + fp.name).toString().
            replace(/[\\[\\]\\"]/, '')
        })
      }
    }

    state.commit('setExibicaoFiltro', exibicao);
  },
  clearFiltroFatura(state) {
    state.commit('setFiltroFatura', {
      empresa: [],
      dataInicial: moment().subtract("1","month").toDate(),
      dataFinal: moment().toDate(),
      formaPagamento: null,
      statusCobranca: null
    });
  },
  buildFiltro(state, {pagination, fatura}) {
    const filtro = fatura ? _.cloneDeep(state.getters.filtroFatura) : _.cloneDeep(state.getters.filtro);
    if (!!pagination && state.getters.pagination) {
      filtro.page = state.getters.pagination.page;
      filtro.limit = state.getters.pagination.limit;
    }
    if(filtro.empresa){
        filtro.empresa = filtro.empresa.map((empresa) => empresa._id);
    }
    if(filtro.formaPagamento){
        filtro.formaPagamento  = filtro.formaPagamento.map(fp => fp.code);
    }
    if (filtro.statusCobranca) {
        filtro.statusCobranca = filtro.statusCobranca.map(st => st.code);
    }
    if(filtro.dataInicial && filtro.dataFinal){
        filtro.dataInicial=moment(filtro.dataInicial).format("DD/MM/YYYY")
        filtro.dataFinal=moment(filtro.dataFinal).format("DD/MM/YYYY")
    }
    state.commit('setFiltroEnvio', filtro);
  },

  async find(state) {
    await state.dispatch('buildFiltro', {pagination: false, fatura: false});
    await state.dispatch('buildExibeFiltro', {fatura: false});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    const resposta = await axios.get("/api/saude/resumo",{
      params: state.getters.filtroEnvio
    });

    return resposta;
  },

  async findExcel(state) {
    await state.dispatch('buildFiltro', {pagination: false, fatura: false});
    await state.dispatch('buildExibeFiltro', {fatura: false});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    const response = await axios.get("/api/saude/resumo-excel",{
      params: state.getters.filtroEnvio,
      responseType: "arraybuffer"
    });

    FileDownload(response.data, 'resumo.xls', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

    return response.data;
  },

  async findDrAchei(state) {
    await state.dispatch('buildFiltro', {pagination: false, fatura: false});
    await state.dispatch('buildExibeFiltro', {fatura: false});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    const resposta = await axios.get("/api/saude/detalhesDrAchei",{
      params: state.getters.filtroEnvio
    });

    return resposta;
  },

  async findDetalhesCliente(state) {
    await state.dispatch('buildFiltro', {pagination: false, fatura: false});
    await state.dispatch('buildExibeFiltro', {fatura: false});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    const resposta = await axios.get("/api/saude/detalhesClientes",{
      params: state.getters.filtroEnvio
    })

    return resposta;
  },

  async findDetalhesEmpresa(state) {
    await state.dispatch('buildFiltro', {pagination: false, fatura: false});
    await state.dispatch('buildExibeFiltro', {fatura: false});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    return await axios.get("/api/saude/detalhesEmpresas",{
      params: state.getters.filtroEnvio
    });
  },

  async findDetalhesFaturas(state) {
    await state.dispatch('buildFiltro', {pagination: true, fatura: true});
    await state.dispatch('buildExibeFiltro', {fatura: true});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    return await axios.get("/api/saude/detalhesFaturas",{
      params: state.getters.filtroEnvio
    });
  },

  async findDetalhesFaturasExcel(state) {
    await state.dispatch('buildFiltro', {pagination: true, fatura: true});
    await state.dispatch('buildExibeFiltro', {fatura: true});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    const response = await axios.get("/api/saude/detalhesFaturas-excel",{
      params: state.getters.filtroEnvio,
      responseType: "arraybuffer"
    });

    FileDownload(response.data, 'faturas.xls', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

    return response;
  },

  async findFaturasAvulsaCartao(state) {
    await state.dispatch('buildFiltro', {pagination: true, fatura: true});
    await state.dispatch('buildExibeFiltro', {fatura: true});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    return await axios.get("/api/saude/detalheFaturaAvulsa",{
      params: state.getters.filtroEnvio
    });
  },

  async findFaturasAvulsaCartaoExcel(state) {
    await state.dispatch('buildFiltro', {pagination: true, fatura: true});
    await state.dispatch('buildExibeFiltro', {fatura: true});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    let response = await axios.get("/api/saude/detalheFaturaAvulsa-excel",{
      params: state.getters.filtroEnvio,
      responseType: "arraybuffer"
    });

    const tipo = state.getters.filtroFatura.tipo ? state.getters.filtroFatura.tipo : 'taxaEmissaoCartao';
    FileDownload(response.data, `faturaAvulsa-${tipo}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

    return response;
  },

  async findDetalheEmpresaExcel(state) {
    await state.dispatch('buildFiltro', {pagination: true, fatura: true});
    await state.dispatch('buildExibeFiltro', {fatura: true});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    let response = await axios.get("/api/saude/detalhesEmpresas-excel",{
      params: state.getters.filtroEnvio,
      responseType: "arraybuffer"
    });

    FileDownload(response.data, 'detalheEmpresa.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

    return response;
  },

  async clearFiltros(state) {
    await state.dispatch('setFiltro', {
      empresa: [],
      dataVencimentoInicial: moment().subtract("1", "month").toDate(),
      dataVencimentoFinal: moment().toDate(),
      formaPagamento: null
    });
  },
  async resumoFaturas(state) {
    await state.dispatch('buildFiltro',{pagination: false, fatura: true});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    return await axios.get("/api/saude/resumoFaturas",{
      params: state.getters.filtroEnvio
    });
  },

  async totalizadorFaturaAvulsa(state) {
    await state.dispatch('buildFiltro',{pagination: false, fatura: true});

    if (state.getters.exibicaoFiltro.length === 0) {
      throw {message: 'Informe pelo menos um filtro do intervalo de datas'};
    }

    return await axios.get("/api/saude/totalizadorFaturasAvulsa",{
      params: state.getters.filtroEnvio
    });
  },
};
